export default __webpack_public_path__ + "static/balazs-pataki-7f4a9c312ba431856711351c0baa5412.png";